import { Button, Modal } from "app/components"
import { useTranslation } from "react-i18next";

import { ComponetnSettingT } from "../types";
import { Dispatch, SetStateAction } from "react";

import styles from './CreateNotificationModal.module.scss';
import { AccessorAndParent } from "../NotificationsPage";

type CreateModalComponentT = {
  componentSetting: [ComponetnSettingT, Dispatch<SetStateAction<ComponetnSettingT>>];
  onClose: () => void
}


const CreateModalComponent = ({ componentSetting, onClose }: CreateModalComponentT) => {
  const { t } = useTranslation();
  const [, setShowCreateRule] = componentSetting;

  const ButtonsList = [
    {
      title: 'ForTheVessel',
      for: 'vessel',
      buttons: [
        {
          iconName: 'catalog-vessels',
          iconSize: '24px',
          label: 'PortArrival',
          show: true,
          type: 'PORT_LOWER_THE_ANCHOR',
          accessor: AccessorAndParent.Port,
          parent: AccessorAndParent.Vessel,
        },
        {
          iconName: 'catalog-vessels',
          iconSize: '24px',
          label: 'DepartureFromPort',
          show: true,
          type: 'PORT_RAISE_THE_ANCHOR',
          accessor: AccessorAndParent.Port,
          parent: AccessorAndParent.Vessel,
        },
        {
          iconName: 'catalog-vessels',
          iconSize: '24px',
          label: 'EnteredTheGeozone',
          show: true,
          type: 'AREA_IN',
          accessor: AccessorAndParent.Area,
          parent: AccessorAndParent.Vessel,
        },
        {
          iconName: 'catalog-vessels',
          iconSize: '24px',
          label: 'LeftTheGeozone',
          show: true,
          type: 'AREA_OUT',
          accessor: AccessorAndParent.Area,
          parent: AccessorAndParent.Vessel,
        },
        {
          iconName: 'catalog-vessels',
          iconSize: '24px',
          label: 'AnchoringOrRemove',
          show: true,
          type: 'ANCHORAGE_ALL',
          accessor: AccessorAndParent.Anchorage,
          parent: AccessorAndParent.Vessel,
        },
        {
          iconName: 'catalog-vessels',
          iconSize: '24px',
          label: 'EmergencySignals',
          show: true,
          type: 'TARGET_SAFETY',
          accessor: AccessorAndParent.TargetSafety,
          parent: AccessorAndParent.Vessel,
        },
      ],
    },
    {
      title: 'ForThePort',
      for: 'port',
      buttons: [
        {
          iconName: 'catalog-ports',
          iconSize: '24px',
          label: 'PortArrival',
          show: true,
          type: 'PORT_LOWER_THE_ANCHOR',
          accessor: AccessorAndParent.Vessel,
          parent: AccessorAndParent.Port,
        },
        {
          iconName: 'catalog-ports',
          iconSize: '24px',
          label: 'DepartureFromPort',
          show: true,
          type: 'PORT_RAISE_THE_ANCHOR',
          accessor: AccessorAndParent.Vessel,
          parent: AccessorAndParent.Port,
        },
      ],
    },
    {
      title: 'ForTheGeozone',
      for: 'area',
      buttons: [
        {
          iconName: 'catalog-areas',
          iconSize: '24px',
          label: 'EnteredTheGeozone',
          show: true,
          type: 'AREA_IN',
          accessor: AccessorAndParent.Vessel,
          parent: AccessorAndParent.Area,
        },
        {
          iconName: 'catalog-areas',
          iconSize: '24px',
          label: 'LeftTheGeozone',
          show: true,
          type: 'AREA_OUT',
          accessor: AccessorAndParent.Vessel,
          parent: AccessorAndParent.Area,
        },
      ],
    },
  ];

  const buttonsFromList =
    ButtonsList.map((section) => {
      return (
        <div className={styles.row} key={section.for}>
          <div className={styles.row_title}>{t(section.title)}:</div>
          <div className={styles.row_list} data-list-parent={section.for}>
            {section.buttons.map((button) => {
              return <Button
                key={t(button.label)}
                className={styles.action_button}
                iconName={button.iconName}
                iconSize={button.iconSize}
                label={t(button.label)}
                variant="custom"
                onClick={() => setShowCreateRule({ show: button.show, type: button.type, accessor: button.accessor, parent: button.parent })}
              />
            })}
          </div>
        </div>
      )
    });

  return (
    <div className={styles.rows}>
      {buttonsFromList}
      <div className={styles.button_group}>
        <Button variant='general' label={t('ButtonLabelDiscard')} type='button' onClick={onClose} />
      </div>
    </div >
  )
}

export const CreateNotificationModal = ({ createNotificationModalState, createNotificationRuleState }: any) => {
  const [showCreateNotificationModal, setShowCreateNotificationModal] = createNotificationModalState;
  const [createNotificationRule] = createNotificationRuleState;
  const { t } = useTranslation();

  return <Modal
    onClose={() => setShowCreateNotificationModal(false)}
    headerTitle={t('NotificationSettings')}
    wrapperClass={styles.rule_modal}
    isShown={showCreateNotificationModal && !createNotificationRule.show}
    component={<CreateModalComponent componentSetting={createNotificationRuleState} onClose={() => setShowCreateNotificationModal(false)} />}
  />
}